module.exports = __webpack_public_path__ + "static/media/dynamic-dash-bg3.2cd90922.svg";